module.exports = __webpack_public_path__ + "img/gn_plan_pointer.3ebbdff2.svg";